import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { agreementFeatureKey, agreementReducer } from './state/agreement.reducer';
import { EffectsModule } from '@ngrx/effects';
import { AgreementEffects } from './state/agreement.effects';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(agreementFeatureKey,agreementReducer),
    EffectsModule.forFeature([AgreementEffects])

  ]
})
export class AgreementModule { }
